import React from "react";
import { Paper, Box, Typography, useTheme } from "@material-ui/core";
import { Sheet, SheetContent } from "../../components";
import { useHeader } from "../../contexts";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const AppointmentPayError = () => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();

  useEffect(() => {
    setTitle(t("appointment.pay_error.title"));
  }, []);

  return (
    <Sheet data-cy="appointment-unavailable">
      <SheetContent>
        <Box mb={2}>
          <Paper>
            <Box p={2} textAlign="center">
              <Typography color="error">
                {t("appointment.pay_error.error")}
              </Typography>
            </Box>
          </Paper>
        </Box>
      </SheetContent>
    </Sheet>
  );
};

export { AppointmentPayError };
